import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { getEnvironment } from 'helpers'

import { setLanguageAction } from 'root-redux/actions/common'
import {
  selectCurrentVariantCohortToUse,
  selectIsInContextShown,
} from 'root-redux/selects/common'

import { useBulkSelector } from 'hooks/common/useBulkSelector'

import { browserHistory } from 'browser-history'
import {
  INITIAL_LANGUAGE,
  LANG_QUERY_PARAM,
  Language,
  SUPPORTED_LOCALES,
} from 'root-constants/common'

const useSelectors = () =>
  useBulkSelector({
    isInContextShown: selectIsInContextShown,
    cohort: selectCurrentVariantCohortToUse,
  })

export const useLanguage = (): void => {
  const dispatch = useDispatch()
  const { isInContextShown } = useSelectors()
  const { i18n } = useTranslation()

  const { isStageEnvironment } = getEnvironment()
  const isInContextActive = isStageEnvironment && isInContextShown
  const { pathname, search } = document.location

  const getLangQueryParam = useCallback(
    () => new URLSearchParams(search).get(LANG_QUERY_PARAM),
    [search],
  )

  // TODO:this logic related to multilang feature
  // const shouldBeLangRewritten = useCallback(
  //   (lang: string) => {
  //     const langParam = getLangQueryParam()
  //     if (langParam) {
  //       return (
  //         SUPPORTED_LOCALES_V2.includes(lang) &&
  //         cohort === Cohort.GOOGLE_9 &&
  //         lang !== langParam
  //       )
  //     }
  //
  //     return false
  //   },
  //   [cohort, getLangQueryParam],
  // )

  useEffect(() => {
    if (!i18n.isInitialized) return

    const langQueryParam = getLangQueryParam()
    let langValue: string

    // TODO: this logic turn on multilang feature
    // const browserLang = i18n.resolvedLanguage
    // if (browserLang && shouldBeLangRewritten(browserLang)) {
    //   langValue = browserLang
    //   eventLogger.logLanguageSwitched(browserLang)
    // } else

    if (langQueryParam && SUPPORTED_LOCALES.includes(langQueryParam)) {
      langValue = langQueryParam
    } else {
      langValue = INITIAL_LANGUAGE
    }

    const selectedLanguage = isInContextActive ? Language.IN_CONTEXT : langValue

    if (langQueryParam && langQueryParam !== selectedLanguage) {
      const updatedParams = new URLSearchParams(search)
      updatedParams.set(LANG_QUERY_PARAM, selectedLanguage)
      browserHistory.replace({
        pathname,
        search: updatedParams.toString(),
      })
    }

    dispatch(setLanguageAction(selectedLanguage))
  }, [
    dispatch,
    getLangQueryParam,
    i18n.isInitialized,
    isInContextActive,
    pathname,
    search,
  ])
}
